var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"options-row"}),_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.data,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }